import { useMemo } from "react";
import { Field, reduxForm, SubmissionError } from "redux-form";
import { Button, Input } from "expano-components";

import { Dashboard, Select } from "components";

import useGet from "hooks/useGet";
import useUpdate from "hooks/useUpdate";

const InputField = (props) => <Input {...props} />;
const SelectField = (props) => <Select {...props} />;

const BasicData = ({
  root_taxon_id,
  refetch,
  initialValues,
  handleSubmit,
  change,
  pristine,
  invalid,
}) => {
  const { is_loading: is_loading_root_taxons, data: root_taxons } = useGet({
    query: ["root_taxons"],
    path: "/root_taxons",
    context: "list",
    search: { per_page: 10_000 },
  });

  const { is_updating, update } = useUpdate({
    path: `/root_taxons/${root_taxon_id}`,
    onSuccess: refetch,
    onError: (err) => {
      throw new SubmissionError(
        Object.fromEntries(
          Object.entries(err).map(([key, value]) => {
            if (["parent"].includes(key)) {
              return [`${key}_id`, value];
            }
            return [key, value];
          })
        )
      );
    },
  });

  const root_taxon_options = useMemo(() => {
    return root_taxons?.map(({ id, name, identifier }) => ({
      label: `[${identifier}] ${name}`,
      value: id,
    }));
  }, [root_taxons]);

  const onSubmit = (values) => update(values);

  return (
    <Dashboard
      header={{ title: "Podstawowe informacje", icon: "info" }}
      footer={
        <>
          <Button
            type="save"
            text={is_updating ? "Proszę czekać..." : "Zapisz"}
            disabled={pristine || invalid || is_updating}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <form
        className="dashboard__form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <Field name="name" label="Nazwa" component={InputField} type="text" />
        <Field
          name="identifier"
          label="Identyfikator"
          component={InputField}
          type="text"
        />
        <Field
          key={is_loading_root_taxons}
          label="Rodzic"
          isDisabled={true}
          name="parent_id"
          component={SelectField}
          defaultValue={
            initialValues.parent_id
              ? root_taxon_options?.find(
                  ({ value }) => value === initialValues.parent_id
                )
              : { label: "Brak", value: null }
          }
          options={root_taxon_options}
          handleChange={(value) => {
            change("parent_id", value);
          }}
        />
      </form>
    </Dashboard>
  );
};

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Nazwa produktu jest wymagana!";
  }

  if (!values.root_taxon_id) {
    errors.root_taxon_id = "Producent jest wymagany!";
  }

  return errors;
};

export default reduxForm({
  form: "update-brand-basic",
  enableReinitialize: true,
  validate,
})(BasicData);
